import * as yup from 'yup';
import {
  ContactInstagramIcon,
  ContactMailIcon,
  ContactPhoneIcon,
  ContactSkypeIcon,
  ContactTelegramIcon,
  ContactViberIcon,
  ContactVKIcon,
  ContactWhatsUpIcon,
} from '@shared/assets/index.ts';

export const contactTypes = [
  'phone',
  'email',
  'telegram',
  'vk',
  'whatsapp',
  'viber',
  'skype',
  'instagram',
] as const;
export type ContactType = (typeof contactTypes)[number];

export const BASE_URL_MAP: Record<ContactType, string> = {
  phone: 'tel:',
  email: 'mailto:',
  telegram: '',
  vk: '',
  whatsapp: 'https://api.whatsapp.com/send?phone=',
  viber: 'viber://chat?number=+',
  skype: 'skype:',
  instagram: '',
};

export const MAP_PLACEHOLDERS: Record<ContactType, string> = {
  phone: '0(000)000-00-00',
  email: 'example@mymail.ex',
  telegram: '',
  vk: 'https://vk.com/your_nickname',
  whatsapp: 'XXXXXXXXXX',
  viber: '0(000)000-00-00',
  skype: 'username',
  instagram: ' http://www.instagram.com/yourusername.',
};

export const contactIconsMap: Record<ContactType, JSX.Element> = {
  phone: <ContactPhoneIcon />,
  email: <ContactMailIcon />,
  telegram: <ContactTelegramIcon />,
  vk: <ContactVKIcon />,
  whatsapp: <ContactWhatsUpIcon />,
  viber: <ContactViberIcon />,
  skype: <ContactSkypeIcon />,
  instagram: <ContactInstagramIcon />,
};

export const contactsVerbMap: Record<ContactType, string> = {
  phone: 'Телефон',
  email: 'Почта',
  telegram: 'Telegram',
  vk: 'ВКонтакте',
  whatsapp: 'WhatsApp',
  viber: 'Viber',
  skype: 'Skype',
  instagram: 'Instagram',
};
export const VALIDATION_PATTERNS: Record<ContactType, RegExp> = {
  phone: /$/,
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  telegram: /$/,
  vk: /^https:\/\/vk\.com\/[a-zA-Z0-9_]+$/,
  whatsapp: /$/,
  viber: /$/,
  skype: /^[a-zA-Z][a-zA-Z0-9_.,-]{3,}$/,
  instagram: /^https:\/\/(www\.)?instagram\.com\/[a-zA-Z0-9_.]+\/?$/,
};

export const contactSchema = yup.object({
  type: yup.string().oneOf(contactTypes).required(),
  value: yup
    .string()
    .required()
    .test('', function (value) {
      const { type } = this.parent;
      const pattern = VALIDATION_PATTERNS[type as ContactType];
      return pattern.test(value);
    }),
});
